<template>
  <v-col
    :id="panelId"
    class="auth-panel-col tw-flex tw-flex-col"
    cols="12"
    sm="12"
    md="6"
    lg="6"
  >
    <div class="auth-panel-inner">
      <div v-if="totalSteps > 1" class="auth-panel-steps" aria-hidden="true">
        <span
          v-for="n in totalSteps"
          :key="n"
          :class="['auth-panel-step', n <= currentStep ? 'auth-panel-step--active' : '']"
        />
      </div>

      <div class="auth-brand">
        <img src="/pacis-logo.png" alt="Pacis Insurance" />
        <p class="auth-tagline">With you every step of the way</p>
      </div>

      <div class="auth-section-divider" aria-hidden="true" />

      <div class="auth-form-wrap">
        <slot />
      </div>

      <footer class="auth-footer">
        <div>
          <a href="https://www.pacisinsurance.com/" target="_blank" rel="noopener">Pacis Website</a>
          <a href="https://www.pacisinsurance.com/terms" target="_blank" rel="noopener">Terms of Use</a>
          <a href="https://www.pacisinsurance.com/privacy" target="_blank" rel="noopener">Privacy Policy</a>
        </div>
        <span>&copy; {{ year }} Pacis Insurance</span>
      </footer>
    </div>
  </v-col>
</template>

<script>
export default {
  name: 'AuthFormPanel',
  props: {
    panelId: { type: String, default: 'auth-panel' },
    totalSteps: { type: Number, default: 1 },
    currentStep: { type: Number, default: 1 },
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>
